module.exports = __webpack_public_path__ + "static/media/mcleod_logo_500.268fd112.png";